import React, { useEffect, useState } from 'react';
import FormSingleResult from '../FormsResultsTable/FormSingleResult';
import { FormsProps, FormsResultsDTO } from '../../types/forms';
import { getFormsRows } from '../../api/forms.api';
import Loading from '../loading/Loading';
import { Typography } from '@mui/material';
import { transformFormResponses } from '../../utils/forms.utils';
import { useEvents } from '../../hooks/useEvents';
import CardiologySingleResult from './CardiologySingleResult';
import { useError } from '../../context/error-context';

const ViewSingleRowForm = ({ formId, linkedFormId, formAllFields }: FormsProps) => {
    const [ results, setResults ] = useState<FormsResultsDTO['responses']>([]);
    const [ resultsLoading, setResultsLoading ] = useState(true);
    const { subscribe } = useEvents();
    const cardiologyHardcodeFormId = 854

    let realFormId = +formId;
    if (linkedFormId) {
        realFormId = linkedFormId;
    }

    const isCardiologyForm = realFormId === cardiologyHardcodeFormId;
    const {showError} = useError();
    useEffect(() => {
        setResultsLoading(true);

        getFormsRows(realFormId)
        .then(response => {
            setResults(response.responses);
        })
        .catch((err) => {
                showError({
                    code: err.response?.status || 500,
                    message: "API Error",
                    description: "Failed to fetch data",
                    showRefresh: true,
                })
            })
        .finally(() => setResultsLoading(false));
    }, [ realFormId , showError]);

    useEffect(() => {
        return subscribe(`REFRESH_FORMS_${realFormId}`, () => {
            setResultsLoading(true);

            getFormsRows(realFormId)
            .then(response => {
                setResults(response.responses);
            })
            .catch((err) => {
                showError({
                    code: err.response?.status || 500,
                    message: "API Error",
                    description: "Failed to fetch data",
                    showRefresh: true,
                })
            })
            .finally(() => setResultsLoading(false));
        });
    }, [realFormId, subscribe, showError]);

    return (
        <div>
            {resultsLoading ? <Loading/> : (
                <div style={{ margin: '16px', maxWidth: '98%', width: 'fit-content' }}>
                    <div>
                        <Typography variant="h4" gutterBottom>Submitted Results</Typography>
                    </div>

                    {formAllFields.length > 0 ? (
                        isCardiologyForm ? (
                            <CardiologySingleResult
                                data={transformFormResponses(results)}
                                fields={formAllFields.filter(item => !item.hidden)}
                            />
                        )
                        : (
                            <FormSingleResult
                                config={{ fields: formAllFields.filter(item => !item.hidden) }}
                                data={transformFormResponses(results)}
                            />
                        )
                    ) : (
                        <Typography variant="h6">
                            Couldn't load the results.
                        </Typography>
                    )}
                </div>
            )}
        </div>
    );
};

export default ViewSingleRowForm;